import {
    CreateMatchPlayerCommandOfMatchPlayer,
    EventVm,
    MatchCoachVm,
    MatchDetailVm,
    UpdateEventCommand,
} from '../../../utils/api';
import MatchEventLog from './MatchEventLog';

interface OwnProps {
    events: EventVm[];
    shootoutEditing?: {
        onApplied: (rows: EventVm[]) => void;
        refresh: () => Promise<void>;
    };
    match?: MatchDetailVm;
    lineups: CreateMatchPlayerCommandOfMatchPlayer[];
    coaches: MatchCoachVm[];
    editEvent: (event: UpdateEventCommand) => void;
    onRefereeMistakeChange: (eventId: number, value: number | null) => void;
}

export type Props = OwnProps;

export default MatchEventLog;
